import { render, staticRenderFns } from "./WidgetToolbar.vue?vue&type=template&id=5d3fb8fb&scoped=true"
import script from "./WidgetToolbar.vue?vue&type=script&lang=js"
export * from "./WidgetToolbar.vue?vue&type=script&lang=js"
import style0 from "./WidgetToolbar.vue?vue&type=style&index=0&id=5d3fb8fb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3fb8fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d3fb8fb')) {
      api.createRecord('5d3fb8fb', component.options)
    } else {
      api.reload('5d3fb8fb', component.options)
    }
    module.hot.accept("./WidgetToolbar.vue?vue&type=template&id=5d3fb8fb&scoped=true", function () {
      api.rerender('5d3fb8fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/editor/WidgetToolbar.vue"
export default component.exports